"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _formik = require("formik");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Button = _interopRequireDefault(require("../Button"));
var View = function View(_ref) {
  var _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? true : _ref$isValid,
    email = _ref.email,
    isOpen = _ref.isOpen,
    onConfirm = _ref.onConfirm,
    toggle = _ref.toggle,
    children = _ref.children,
    minLength = _ref.minLength;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: isOpen,
    onClose: toggle
  }, /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      email: email
    },
    onSubmit: function onSubmit(values) {
      return onConfirm(values.email);
    }
  }, function (formikProps) {
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "p-12"
    }, /*#__PURE__*/_react["default"].createElement("h1", {
      className: "font-bold text-dark text-2xl"
    }, t('premium.changeEmailAddress.title')), /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-light"
    }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
      i18nKey: "premium.changeEmailAddress.description",
      values: {
        minLength: minLength
      }
    }, /*#__PURE__*/_react["default"].createElement("b", null))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mt-10 mb-16"
    }, children), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "button",
      color: "secondary",
      className: "w-32 mr-4",
      onClick: toggle
    }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      disabled: !(isValid && formikProps.isValid),
      type: "submit",
      className: "w-32"
    }, t('button.update')))));
  }));
};
View.displayName = 'ChangeEmailConfirmation';
var _default = exports["default"] = View;
//# sourceMappingURL=ChangeEmailConfirmation.js.map